import { render, staticRenderFns } from "./StackHeaderInfo.vue?vue&type=template&id=68a52ef3&scoped=true&"
import script from "./StackHeaderInfo.vue?vue&type=script&lang=js&"
export * from "./StackHeaderInfo.vue?vue&type=script&lang=js&"
import style0 from "./StackHeaderInfo.vue?vue&type=style&index=0&id=68a52ef3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a52ef3",
  null
  
)

export default component.exports